export default () => {
    let projectNav = document.getElementById('js-project-nav');

    if (!projectNav)
        return;

    let BREAKPOINT = 768;
    let UNSTUCK_CLASS = 'unstuck-main-menu';
    let FIXED_CLASS   = 'project-fixed-menu';
    let _body = document.body;
    let siteNavHeight = 74;
    let siteNav = document.getElementById('header-inner');
    let headerModule = document.getElementById('videoHeaderContent');

    let headerModuleHeight = headerModule.offsetHeight;
    let projectNavHeight   = projectNav.offsetHeight;
    let triggerHeight = headerModuleHeight - projectNavHeight;

    let triggerStickiness = function (remove) {
        if (!remove) {
            _body.classList.add(UNSTUCK_CLASS);
            siteNav.style.marginTop = headerModuleHeight + 'px';
            siteNav.style.top = '-' + (projectNavHeight + siteNavHeight) + 'px';
        } else {
            siteNav.style.marginTop = '';
            siteNav.style.top = '';
            _body.classList.remove(UNSTUCK_CLASS);
        }
    };

    let triggerProjectMenu = function (remove) {
        if (!remove) {
            _body.classList.add(FIXED_CLASS);
        } else {
            _body.classList.remove(FIXED_CLASS);
        }
    };

    let triggerFunction = function (conditionIf, functionIf, conditionElse, functionElse) {
        if (conditionIf) {
            functionIf();
        } else if (conditionElse) {
            functionElse();
        }
    };

    window.addEventListener('resize', function () {
        headerModuleHeight = headerModule.offsetHeight;
        projectNavHeight   = projectNav.offsetHeight;
        triggerStickiness(true);
    }, false);

    window.addEventListener('scroll', function () {
        onScroll();
    }, false);

    function onScroll() {
        if ((window.innerWidth || document.documentElement.clientWidth) < BREAKPOINT) {
            triggerFunction(
                !_body.classList.contains(UNSTUCK_CLASS) && window.scrollY >= triggerHeight,
                triggerStickiness.bind(null, false),
                _body.classList.contains(UNSTUCK_CLASS) && window.scrollY < triggerHeight,
                triggerStickiness.bind(null, true));

            triggerFunction(
                !_body.classList.contains(FIXED_CLASS) && window.scrollY >= (headerModuleHeight - projectNavHeight + 74),
                triggerProjectMenu.bind(null, false),
                _body.classList.contains(FIXED_CLASS) && window.scrollY < (headerModuleHeight - projectNavHeight + 74),
                triggerProjectMenu.bind(null, true));
        }
    }

    onScroll();
}